export enum FieldTypesEnum {
  title = 1,
  check = 2,
  input = 3,
  select = 4,
  rate = 5,
}
